import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEmpty } from 'lodash';
import { loadCurrentUserStream, createComment, createLike, destroyLike, homeStreamEntriesSelector, loadStreamPrevious, loadStreamNext } from '../redux/modules/stream';
import EntriesList from '../views/entriesList';

const mapStateToProps = state => {
  const showLoadPreviousEntries = !state.stream.loadingPrevious && !isEmpty(state.stream.previousUrl);
  const showLoadNextEntries = !state.stream.loadingNext && !isEmpty(state.stream.nextUrl);

  return {
    homeStreamLoading: state.stream.loading,  
    homeStreamLoaded: state.stream.loaded,
    homeStreamLoadingError: state.stream.error,
    homeStream: homeStreamEntriesSelector(state),
    entriesCommentStatusById: state.stream.entriesCommentStatusById,
    entriesLikeStatusById: state.stream.entriesLikeStatusById,
    showLoadPreviousEntries: showLoadPreviousEntries,
    showLoadNextEntries: showLoadNextEntries
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ loadCurrentUserStream, createComment, createLike, destroyLike, loadStreamPrevious, loadStreamNext }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EntriesList);



// WEBPACK FOOTER //
// ./src/containers/homeStream.js